import { useCallback } from "react";
import { parseSafeHttpUrl } from "@/utils";

export const SOURCE_STORAGE_KEY = "source";
export const SOURCE_QUERY_PARAM_KEY = "source";

/**
 * Captures the ?source query param into sessionStorage at app boot so it
 * survives Auth0 redirects for the rest of the browser session.
 * Call once in main.tsx before createRoot.
 */
export function captureSourceUrlFromQuery(): void {
  const source = new URLSearchParams(window.location.search).get(SOURCE_QUERY_PARAM_KEY);
  storeSourceUrl(source);
}

/**
 * Store a source URL in sessionStorage so the back button can navigate to it.
 * Validates the URL before storing.
 */
export function storeSourceUrl(sourceUrl: unknown): void {
  const safeSourceUrl = parseSafeHttpUrl(sourceUrl);
  if (safeSourceUrl) {
    sessionStorage.setItem(SOURCE_STORAGE_KEY, safeSourceUrl.toString());
  }
}

export function useBackNavigation() {
  const storedSourceUrl = sessionStorage.getItem(SOURCE_STORAGE_KEY);

  const canGoBack = Boolean(parseSafeHttpUrl(storedSourceUrl));

  const goBack = useCallback(() => {
    const safeUrl = parseSafeHttpUrl(sessionStorage.getItem(SOURCE_STORAGE_KEY));
    if (!safeUrl) return;
    sessionStorage.removeItem(SOURCE_STORAGE_KEY);
    window.location.assign(safeUrl.toString());
  }, []);

  return { goBack, canGoBack };
}
